var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76486 15.4419C8.52078 15.686 8.12505 15.686 7.88097 15.4419L2.88097 10.4419C2.6369 10.1979 2.6369 9.80214 2.88097 9.55806L7.88097 4.55806C8.12505 4.31398 8.52078 4.31398 8.76486 4.55806C9.00894 4.80214 9.00894 5.19786 8.76486 5.44194L4.8318 9.375L16.6562 9.375C17.0014 9.375 17.2812 9.65482 17.2812 10C17.2812 10.3452 17.0014 10.625 16.6562 10.625L4.8318 10.625L8.76486 14.5581C9.00894 14.8021 9.00894 15.1979 8.76486 15.4419Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBackArrow);
export default __webpack_public_path__ + "static/media/left-back-arrow.e584f92cd20ed5d3e62a56048a5526f0.svg";
export { ForwardRef as ReactComponent };